module.exports = __webpack_public_path__ + "static/media/HelveticaNowDisplayXBlk.193d65be.otf";